/**
* 模版
**/

<template>
  <div>
    <!-- <div class=" ks clearfix" v-for="(item1,index) in attributelist" :key="index"> -->
    <div>
      <div class="kuanshi fl">{{ attributelist.bxyname }} :</div>
      <div class="kuanshi-two fl kuanshi-two2">
        <el-radio-group v-model="goodsSize" size="medium">
          <!-- <el-radio border :label="item2.id" @change="getgoodsSizeArr(item2.bxysid,item2.id)" v-for="(item2,index) in attributelist.bXyAttributeList" :key="index">{{item2.name
          }}</el-radio> -->
          <el-radio border :label="item2.id" @change="getgoodsSizeArr(item2)"
                    v-for="(item2,index) in attributelist.bXyAttributeList" :key="index">{{ item2.name }}
          </el-radio>
        </el-radio-group>
      </div>
      <span class="select_c" id="select_c"><i></i>&nbsp;请输入选择材质</span>
    </div>
  </div>
</template>

<script>
// 导出模块
export default {
  // 模块名字
  name: 'goodsSize',
  // 模块数据
  data() {
    //数据
    return {
      goodsSize: ''
      // goodsIdArr:[]
    };
  },
  props: ['attributelist', 'getgoodsSize', 'goodsIdArr'],
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 创建前状态(里面是操作)
  beforeCreate() {
  },
  // 创建完毕状态(里面是操作)
  created() {
  },
  // 挂载前状态(里面是操作)
  beforeMount() {
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    this.goodsSize = this.attributelist.bXyAttributeList[0].id
    this.getgoodsSizeArr(this.attributelist.bXyAttributeList[0])
  },
  // 更新前状态(里面是操作)
  beforeUpdate() {
  },
  // 更新完成状态(里面是操作)
  updated() {
  },
  // 销毁前状态(里面是操作)
  beforeDestroy() {
  },
  // 销毁完成状态(里面是操作)
  destroyed() {
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    getgoodsSizeArr(item) {
      // getgoodsSizeArr(bxysid,id){
      // const obj = {
      //         bxysid:bxysid,
      //         id:id
      //     }
      // const idx = this.goodsIdArr.findIndex(i => i.bxysid == obj.bxysid)
      // idx < 0 ? this.goodsIdArr.push(obj) : this.goodsIdArr.splice(idx, 1, obj)
      // this.getgoodsSize(this.goodsIdArr)

      const obj = item
      const idx = this.goodsIdArr.findIndex(i => i.bxysid == obj.bxysid)
      idx < 0 ? this.goodsIdArr.push(obj) : this.goodsIdArr.splice(idx, 1, obj)
      this.getgoodsSize(this.goodsIdArr)
    }
  },

};
</script>
// scoped 样式只在本组件使用
<style scoped>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
</style>



// WEBPACK FOOTER //
// src/components/goodsSize.vue